import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Resources module configurations
export const LISTING_COLUMNS = [
  {
    id: 'name',
    label: 'Resource Name',
    width: '25%',
    align: 'left',
    dataKey: 'name',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'type',
    label: 'Type',
    width: '15%',
    align: 'left',
    dataKey: 'type',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'filename',
    label: 'File Name',
    width: '15%',
    align: 'left',
    dataKey: 'filename',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'fileSize',
    label: 'Size',
    width: '15%',
    align: 'center',
    dataKey: 'fileSize',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'createdAt',
    label: 'Uploaded At',
    width: '25%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.COPY.value,
    label: ACTIONS.COPY.label,
    icon: 'clarity:copy-line',
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];
